interface StatisticsParams {
    /**
     * 动作类型编号
     */
    ac: string;
    /**
     * 备注说明
     */
    opt_rm: string;
    /**
     * 备注值
     */
    opt_val: string;
}

class statistics {
    public loaded: boolean = false;

    public triggerQueue: StatisticsParams[] = [];

    load(userId: string) {
        if (this.loaded) {
            return;
        }
        let _sid = '1025';

        let _secret = 'E2qR0kzbHfUYnPJT1pWrGDXQmy9uZxg3';

        let uid = userId;

        let _uid = window.btoa(encodeURIComponent(uid));

        let _ev = ENV.TRACK_EV;

        let script = document.createElement('script');

        script.src =
            'https://its.huaxiapawn.com:1443/track/js/tk.js?' + _sid + '&' + _secret + '&' + _uid + '&' + _ev;

        let s = document.getElementsByTagName('script')[0];

        s.parentNode!.insertBefore(script, s);

        script.onload = () => {
            this.loaded = true;
            this.triggerQueue.forEach((item) => {
                const { ac, opt_rm, opt_val } = item;
                this.trigger(ac, opt_rm, opt_val);
            });
            this.triggerQueue = [];
        };
    }

    trigger(ac: string, opt_rm: string, opt_val: string) {
        if ((window as any)._trackEvent) {
            _trackEvent(ac, opt_rm, opt_val);
        } else {
            this.triggerQueue.push({
                ac,
                opt_rm,
                opt_val
            });
        }
    }
}

let StatisticsInstance = new statistics();

export { StatisticsInstance as statistics };
